import { motion } from "framer-motion";
import { useI18n } from "@/i18n/I18nContext";

export default function Manifesto() {
  const { t } = useI18n();
  const chapters = t("manifesto.chapters");

  return (
    <section id="about" className="scroll-mt-24 border-y border-border bg-secondary/30">
      <div className="mx-auto max-w-[1400px] px-5 py-24 md:px-10 md:py-32">
        <div className="mb-16 flex items-center gap-4">
          <span className="h-px w-12 bg-primary" />
          <h2 className="font-display text-sm font-semibold uppercase tracking-[0.3em] text-primary">
            {t("manifesto.title")}
          </h2>
        </div>

        <div className="space-y-px">
          {chapters.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
              className="group grid grid-cols-1 items-start gap-6 border-t border-border py-10 md:grid-cols-12 md:gap-10"
            >
              <div className="md:col-span-3">
                <span className="font-display text-6xl font-bold leading-none text-foreground/10 transition-colors duration-500 group-hover:text-primary md:text-8xl">
                  {c.n}
                </span>
              </div>
              <h3 className="font-display text-2xl font-semibold uppercase tracking-tight md:col-span-4 md:text-3xl">
                {c.t}
              </h3>
              <p className="text-muted-foreground md:col-span-5 md:text-lg md:leading-relaxed">
                {c.d}
              </p>
            </motion.div>
          ))}
          <div className="border-t border-border" />
        </div>
      </div>
    </section>
  );
}
